<template>
  <navbar>
    <my-button @click="$router.push('/profile')">profile</my-button>
  </navbar>

  <my-dialog v-model:show="showEditor">
    <!-- <cocktail-editor :cocktail="cocktail_e"></cocktail-editor> -->
    <cocktail-editor :cocktailID="cocktailID"
      @hide-event="showEditor=false"
      @update-cocktails="load_cocktails()"
    ></cocktail-editor>
  </my-dialog>

  <div class="body">
    <cocktail v-for="cocktail in cocktails" :cocktail="cocktail" :key="cocktail.id"
      @click="openEditor(cocktail)" :isRedirect="false"
    ></cocktail>

    <div style="margin: 50px 0;">
      <my-button class="btn_green">+</my-button>
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue';
import Cocktail from '@/components/Cocktail.vue';
import CocktailEditor from '@/components/CocktailEditor.vue';

export default {
  components: {
    Navbar, Cocktail, CocktailEditor
  },
  data() {
    return {
      cocktails: [],
      showEditor: false,
      // cocktail_e: {},
      cocktailID: 0,
      //   // active: Boolean,
      //   active: false,
      // }
      // cocktails_info: []
    }
  },
  methods: {
    async load_cocktails() {
      let res = await fetch("/api/barman/get_cocktails", {
        method: "POST",
        headers: {"content-type": "application/json"}
      })
      if (res.status === 200) {
        let data = await res.json();
        // console.log(data);
        this.cocktails = data.cocktails;
        // this.cocktails_info = data.cocktails;
      }
    },
    async openEditor(cocktail) {
      this.showEditor = true;
      // this.cocktail_e = cocktail;
      this.cocktailID = cocktail.id;
    },
    async isauth() {
      let res = await fetch('/api/auth/isauth', {
        method: "POST",
        headers: {"content-type": "application/json"},
      });
      if (res.status === 200) {
        let data = await res.json();
        // console.log(data['auth']);
        if (!data['auth']) {
          this.$router.push('/auth/log_in');
        }
      }
    }
  },
  computed: {
    cocktails() {
      // let render_cocktails = [...this.cocktails];
      let render_cocktails = JSON.parse(JSON.stringify(this.cocktails));
      for (let i in render_cocktails) {
        for (let j in render_cocktails[i].ingredients) {
          // console.log(render_cocktails[i].ingredients[j]);
          let ingrs_A = render_cocktails[i].ingredients[j];
          render_cocktails[i].ingredients[j] = ingrs_A.join(' ');
        }
      }
      return render_cocktails;
    }
  },
  mounted() {
    this.isauth();
    this.load_cocktails();
  }
}
</script>

<style scoped>
.body {
  padding: 35px;
}
.btn_green {
  width: 100%;
  /* width: calc(100% - 32px); */
  /* margin: auto; */
  /* padding: 0 100%; */
  border: 5px solid lightgreen;
}
</style>
